module.exports = __webpack_public_path__ + "img/bg.a11bc56a.png";